/* eslint-disable angular/timeout-service */

export const syncScrollComponentModule = angular
  .module('Q.components.sync-scroll', [])

  // Directives to allow you to synchronize scrolling across multiple
  // overflowed elements

  // Requires providing a key to sync scrolling on

  .directive('syncScroll', function (syncScrollService) {
    return {
      restrict: 'A',
      link(scope, elem, attr) {
        const key = attr.syncScroll;
        if (key) {
          const relative = attr.syncScrollAbsolute !== 'false';
          const shouldListen = attr.syncScrollListen !== 'false';

          syncScrollService.addElement(key, elem, relative, shouldListen);

          scope.$on('$destroy', () =>
            syncScrollService.removeElement(key, elem),
          );
        }
      },
    };
  })

  .directive('codemirrorSyncScroll', function (syncScrollService) {
    return {
      restrict: 'A',
      require: 'uiCodemirror',
      link(scope, elem, attr, uiCodemirrorCtrl) {
        const key = attr.codemirrorSyncScroll;
        if (key) {
          let scrollElement;
          const relative = attr.syncScrollAbsolute !== 'false';
          const shouldListen = attr.syncScrollListen !== 'false';

          uiCodemirrorCtrl.whenReady().then(() => {
            scrollElement = elem.querySelector('.CodeMirror-scroll');
            syncScrollService.addElement(
              key,
              scrollElement,
              relative,
              shouldListen,
            );
          });

          scope.$on('$destroy', () =>
            syncScrollService.removeElement(key, scrollElement),
          );
        }
      },
    };
  })

  .factory('syncScrollService', function ($window) {
    const keys = {};

    const svc = {
      addElement(key, $el, relative, shouldListen) {
        if (!keys[key]) {
          keys[key] = [];
          keys[key].scrollFn = _onScroll(key);
        }
        keys[key].push({ relative, $el, el: $el[0] });
        if (shouldListen !== false) {
          $el.on('scroll', keys[key].scrollFn);
        }
      },

      removeElement(key, $el) {
        if ($el && $el[0] && keys[key]) {
          let idx = keys[key].find((e) => e.el === $el[0]);
          if (idx > -1) {
            $el.off('scroll', keys[key].scrollFn);
            keys[key].splice(idx, 1);
          }
          if (keys[key].length === 0) {
            delete keys[key];
          }
        }
      },

      pause(key) {
        svc.setPaused(key, true);
      },

      resume(key) {
        svc.setPaused(key, false);
      },

      setPaused(key, paused) {
        if (keys[key]) {
          keys[key].paused = paused;
        }
      },
    };

    return svc;

    //// private functions

    function _onScroll(key) {
      let eventTarget;
      return function ($event) {
        if (keys[key].paused) return;
        if (eventTarget && eventTarget !== $event.target) return;
        eventTarget = $event.target;

        const target = $event.target;
        const offset = target.scrollTop;
        const relativeOffset =
          offset / (target.scrollHeight - target.clientHeight);

        keys[key].forEach(function ({ relative, el }) {
          if (el !== eventTarget) {
            let scrollTo = offset;
            if (relative) {
              scrollTo = relativeOffset * (el.scrollHeight - el.clientHeight);
            }
            el.scrollTop = scrollTo;
          }
        });

        $window.setTimeout(() => (eventTarget = null), 100);
      };
    }
  });
